import { render, staticRenderFns } from "./AlldocsRecipeList.vue?vue&type=template&id=1b8ad91e&"
import script from "./AlldocsRecipeList.vue?vue&type=script&lang=js&"
export * from "./AlldocsRecipeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports